/**
 * Route paths that more than one module needs to agree on.
 *
 * WHY THIS EXISTS: the per-runtime monitoring page lives at `/runtime`, but
 * `ConnectionStatus` had FOUR hardcoded comparisons against `"/"` — the path it
 * used to live at. `/` now redirects to `/orgs`, so the "View Runtime" pill sent
 * the operator to Organizations, `onRuntimePage` never matched (the pill never
 * hid itself on the very page it links to), and disconnecting from the runtime
 * page failed to bounce back to the fleet. A route rename that missed its
 * consumers, silent because a redirect made every wrong path still render
 * *something*.
 *
 * Importing the constant on both sides is what makes that class of drift
 * impossible rather than merely tested-for.
 */

/** The per-runtime monitoring page (`RuntimeOverview`, all tabs). */
export const RUNTIME_PAGE_PATH = "/runtime";

/** The fleet list — where a disconnect returns you. */
export const RUNTIME_FLEET_PATH = "/runtimes";

/** The platform Specialists section (S1 roster + S2 attributes view). */
export const SPECIALISTS_PATH = "/specialists";
